import { FileIconType } from "@fluentui/react-file-type-icons";
import { SharePointFolderContentTypeIds } from "../../config/constants";
import { IFolderInfo } from "../../interfaces/IFolderInfo";
import { FolderTypeEnum } from "../enums/FolderTypeEnum";
import { FolderTypeIconEnum } from "../enums/FolderTypeIconEnum";
import { ImageTypeEnum } from "../enums/ImageTypeEnum";
import { BrandIcons } from "../../config/brandIcons";
import React from "react";
import { Channel20Regular } from "../_v2/components/SvgIcons/Channel20Regular";
import { FolderDocument20Regular } from "../_v2/components/SvgIcons/FolderDocument20Regular";
import { SquareMultiple20Regular } from "../_v2/components/SvgIcons/SquareMultiple20Regular";

export class FolderTypeIconQuery {
    private static FolderTypeIconToTypeDictionary = {
        [FolderTypeIconEnum.default.toString()]: FolderTypeEnum.default,
        [FolderTypeIconEnum.sharepointFolder.toString()]: FolderTypeEnum.sharepoint,
        [FolderTypeIconEnum.sharepointSite.toString()]: FolderTypeEnum.sharepointSite,
        [FolderTypeIconEnum.documentLibrary.toString()]: FolderTypeEnum.sharepoint,
        [FolderTypeIconEnum.oneDrive.toString()]: FolderTypeEnum.oneDrive,
        [FolderTypeIconEnum.teamChannel.toString()]: FolderTypeEnum.teamChannel,
        [FolderTypeIconEnum.teamMainSite.toString()]: FolderTypeEnum.teamMainSite,
        [FolderTypeIconEnum.oneDriveSubFolder.toString()]: FolderTypeEnum.oneDriveSubFolder,
        [FolderTypeIconEnum.sharepointDocumentSet.toString()]: FolderTypeEnum.sharepoint,
        [FolderTypeIconEnum.sharepointList.toString()]: FolderTypeEnum.sharepointList,
        [FolderTypeIconEnum.sharepointHubSite.toString()]: FolderTypeEnum.sharepointHubSite,
        [FolderTypeIconEnum.docubird.toString()]: FolderTypeEnum.docubird
    }

    private static FolderTypeIconToImageUrl = {
        [FolderTypeIconEnum.default.toString()]: { imageType: ImageTypeEnum.fileType, fileIconType: FileIconType.folder },
        [FolderTypeIconEnum.sharepointFolder.toString()]: { imageType: ImageTypeEnum.fileType, fileIconType: FileIconType.folder },
        [FolderTypeIconEnum.oneDrive.toString()]: { imageType: ImageTypeEnum.url, location: BrandIcons.OneDrive20 },
        [FolderTypeIconEnum.oneDriveSubFolder.toString()]: { imageType: ImageTypeEnum.fileType, fileIconType: FileIconType.folder },
        [FolderTypeIconEnum.teamFolder.toString()]: { imageType: ImageTypeEnum.fileType, fileIconType: FileIconType.folder },
        [FolderTypeIconEnum.sharepointSite.toString()]: { imageType: ImageTypeEnum.url, location: BrandIcons.SharePoint20 },        
        [FolderTypeIconEnum.documentLibrary.toString()]: { imageType: ImageTypeEnum.svgComponent, svgComponent: <FolderDocument20Regular /> },
        [FolderTypeIconEnum.teamMainSite.toString()]: { imageType: ImageTypeEnum.url, location: BrandIcons.Teams20 },        
        [FolderTypeIconEnum.teamChannel.toString()]: { imageType: ImageTypeEnum.svgComponent, svgComponent: <Channel20Regular /> },
        [FolderTypeIconEnum.sharepointDocumentSet.toString()]: { imageType: ImageTypeEnum.fileType, fileIconType: FileIconType.docset },
        [FolderTypeIconEnum.sharepointList.toString()]: { imageType: ImageTypeEnum.fileType, fileIconType: FileIconType.list },
        [FolderTypeIconEnum.sharepointHubSite.toString()]: { imageType: ImageTypeEnum.svgComponent, svgComponent: <SquareMultiple20Regular /> },
        [FolderTypeIconEnum.docubird.toString()]: { imageType: ImageTypeEnum.url, location: `${process.env.baseUri}/assets/modern-icon-20.svg` }
    }

    static getFolderType = (folderTypeIcon: FolderTypeIconEnum) => {
        if (folderTypeIcon) {
            return FolderTypeIconQuery.FolderTypeIconToTypeDictionary[folderTypeIcon.toString()];
        }
        return FolderTypeEnum.default;
    }

    static getImage = (folderTypeIcon: FolderTypeIconEnum) => {
        if (folderTypeIcon) {
            return FolderTypeIconQuery.FolderTypeIconToImageUrl[folderTypeIcon.toString()];
        }
        return FolderTypeIconQuery.FolderTypeIconToImageUrl[FolderTypeIconEnum.default.toString()];
    }

    static getIconType = (folderType: FolderTypeEnum, info: IFolderInfo, isTeamFolder: boolean = false): FolderTypeIconEnum => {
        switch (folderType) {
            case FolderTypeEnum.default:
                return FolderTypeIconEnum.default
            case FolderTypeEnum.sharepoint:
                return FolderTypeIconQuery.determineSharePointIconType(info, isTeamFolder)
            case FolderTypeEnum.sharepointSite:
                return FolderTypeIconEnum.sharepointSite
            case FolderTypeEnum.oneDrive:
                return FolderTypeIconEnum.oneDrive
            case FolderTypeEnum.teamChannel:
                return FolderTypeIconEnum.teamChannel
            case FolderTypeEnum.teamMainSite:
                return FolderTypeIconEnum.teamMainSite
            case FolderTypeEnum.oneDriveSubFolder:
                return FolderTypeIconEnum.oneDriveSubFolder
            case FolderTypeEnum.sharepointList:
                return FolderTypeIconEnum.sharepointList
            case FolderTypeEnum.sharepointHubSite:
                return FolderTypeIconEnum.sharepointHubSite
            case FolderTypeEnum.docubird:
                return FolderTypeIconEnum.docubird
        }
    }

    private static determineSharePointIconType = (info: IFolderInfo, isTeamFolder: boolean): FolderTypeIconEnum => {
        if (info.driveId && !info?.id) return FolderTypeIconEnum.documentLibrary;
        if (isTeamFolder) return FolderTypeIconEnum.teamFolder;
        if (info.contentTypeId?.startsWith(SharePointFolderContentTypeIds.documentSet)) return FolderTypeIconEnum.sharepointDocumentSet;
        return FolderTypeIconEnum.sharepointFolder
    }
}